import React from "react"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

/**
 * 検索条件表示オブジェクトコンポーネント
 * @param displaySearchCondition 検索条件
 * @returns
 */
const DisplaySearchConditionLabel: React.FC<{
  displaySearchCondition: any | undefined
}> = ({ displaySearchCondition }) => {
  const toReactElement = (value: any): React.ReactElement => {
    if (typeof value === "boolean") {
      return (
        <>
          <FontAwesomeIcon
            className={"fa-icon"}
            icon={faCheck}></FontAwesomeIcon>
        </>
      )
    } else {
      return <>{value}</>
    }
  }

  if (displaySearchCondition) {
    return (
      <div className="preSearchCondition selectable">
        {Object.keys(displaySearchCondition)
          .filter((key) => displaySearchCondition[key])
          .map((key) => (
            <span key={key}>
              {`[${key}]:`}&nbsp;
              {toReactElement(displaySearchCondition[key])}
            </span>
          ))}
      </div>
    )
  } else {
    return <></>
  }
}

export default DisplaySearchConditionLabel
